import React from 'react';
import GameList from "../list/game_list";
import {exportNewCasinoJson} from "../../data/gameData_casino";
import {exportNewSlotJson} from "../../data/gameData_slot";
import GameLoading from "../provider/game_loading_provider";

function MainGameListLayout() {
    return (
        <div className={"game-list-layout"}>
            <GameList title={'라이브 카지노'} type={'casino'} list={exportNewCasinoJson as []}/>
            <GameList title={'슬롯머신'}      type={'slot'}   list={exportNewSlotJson as []}/>
        </div>
    );
}

export default MainGameListLayout;

